<template>
  <v-app>
    <v-navigation-drawer
      id="appDrawer"
      v-if="
        $store.getters.company !== null &&
          $store.getters.userDetails !== null &&
          $store.getters.userDetails !== undefined &&
          $router.currentRoute.name != 'Login' &&
          $router.currentRoute.name != 'Setup'
      "
      :dark="true"
      v-model="sideNav"
      app
      color="#284259"
    >
      <v-list-item
        v-if="'companyLogo' in $store.getters.company && $store.getters.company.companyLogo != ''"
        style="background-color:#1976D2;max-height:90px"
      >
        <v-list-item-content>
          <v-list-item-title class="title">
            <v-img
              :src="getImageAttachment($store.getters.company.companyLogo)"
              height="36px"
              alt="Company Logo"
              style="width: 36px; border-radius: 50px; margin-top: 3px; margin-left: 5px"
            ></v-img>
          </v-list-item-title>
          <v-list-item-subtitle>{{ $store.getters.company.name }}</v-list-item-subtitle>
          <v-list-item-subtitle>{{ $store.getters.company.country }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-else
        color="#327dc8"
        height="56px"
        style="background-color:#1976D2;max-height:64px"
      >
        <v-list-item-content>
          <v-list-item-title class="title">
            <img v-bind:src="computeLogo" height="48px" alt="Regular.li" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-if="
          $store.getters.userDetails !== null &&
            $store.getters.userDetails !== undefined &&
            $router.currentRoute.name != 'Login' &&
            $router.currentRoute.name != 'Setup'
        "
      >
        <v-list-item-avatar>
          <v-img
            v-bind:src="defaultImage"
            @click="zoom(defaultImage)"
            height="50"
            style="width: 52px; border-radius: 50px; "
          ></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <h5 class="sidebar-h5 font-weight-heavy">{{ $store.state.userDetails.firstName }}</h5>
          <p class="sidebar-p font-weight-regular">{{ $store.state.userDetails.email }}</p>
          <p class="sidebar-p" font-weight-regular>{{ $store.getters.company.name }}</p>
        </v-list-item-content>
      </v-list-item>

      <v-list
        v-if="
          $store.getters.company !== null &&
            $store.getters.userDetails !== null &&
            $store.getters.userDetails !== undefined &&
            $router.currentRoute.name != 'Login' &&
            $router.currentRoute.name != 'Setup'
        "
      >
        <v-list-item v-for="item in menuItems" :key="item.title" :to="item.link">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="items_title">{{ item.title }}</v-list-item-title>
        </v-list-item>

        <v-list-group no-action prepend-icon="settings">
          <template slot="activator">
            <v-list-item-title class="items_title">Settings</v-list-item-title>
          </template>

          <v-list-item :to="'/locations'">
            <v-list-item-icon>
              <v-icon>location_on</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Locations</v-list-item-title>
          </v-list-item>

          <v-list-item :to="'/tags'" v-if="$store.state.userDetails.role == 'SuperAdmin'">
            <v-list-item-icon>
              <v-icon>local_play</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Tags & Groups</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="'/shifts'"
            v-if="
              $store.state.userDetails.role == 'SuperAdmin' ||
                $store.state.userDetails.role == 'Admin'
            "
          >
            <v-list-item-icon>
              <v-icon>filter_tilt_shift</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Shifts</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="'/weeklyoff'"
            v-if="
              $store.state.userDetails.role == 'SuperAdmin' ||
                $store.state.userDetails.role == 'Admin'
            "
          >
            <v-list-item-icon>
              <v-icon>weekend</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Weeklyoff</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="'/holiday'"
            v-if="
              $store.state.userDetails.role == 'SuperAdmin' ||
                $store.state.userDetails.role == 'Admin'
            "
          >
            <v-list-item-icon>
              <v-icon>work_off</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Holiday</v-list-item-title>
          </v-list-item>

          <v-list-item :to="'/forms'">
            <v-list-item-icon>
              <v-icon>assignment</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Forms</v-list-item-title>
          </v-list-item>

          <v-list-item :to="'/profile'">
            <v-list-item-icon>
              <v-icon>people</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Profile</v-list-item-title>
          </v-list-item>

          <v-list-item :to="'/notificationslist'">
            <v-list-item-icon>
              <v-icon>alarm</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Notifications</v-list-item-title>
          </v-list-item>

          <v-list-item :to="'/subscription'" v-if="canSee('viewSubscription')">
            <v-list-item-icon>
              <v-icon>credit_card</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="items_title">Subscription</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item :to="'/reports'">
          <v-list-item-icon>
            <v-icon>assessment</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="items_title">Reports</v-list-item-title>
        </v-list-item>

        <v-list-item :to="'/fieldtrackingreports'">
          <v-list-item-icon>
            <v-icon>nature_people</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="items_title">Field Tracking</v-list-item-title>
        </v-list-item>

        <v-list-item :to="'/help'">
          <v-list-item-icon>
            <v-icon>contact_support</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="items_title">Help</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="
            $store.getters.company !== null &&
              $store.getters.userDetails !== null &&
              $store.getters.userDetails !== undefined &&
              $router.currentRoute.name != 'Login'
          "
          @click="onLogout"
        >
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="items_title">Logout</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="'companyLogo' in $store.getters.company && $store.getters.company.companyLogo != ''"
        >
          <v-list-item-title style="text-align: center; margin-left: -12px; margin-top: 10px">
            <img
              v-if="
                'companyLogo' in $store.getters.company && $store.getters.company.companyLogo != ''
              "
              v-bind:src="computeLogo"
              height="45"
              alt="Regular.li"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item> </v-list-item>
      </v-list>

      <!--<v-footer absolute style="text-align: center !important">
        
      </v-footer>-->

      <v-footer absolute style="text-align: center !important">
        <div style="font-size: 14px">2020 &copy;Regular.li</div>

        <v-spacer></v-spacer>
        <div style="font-size: 13px; ">Version: {{ $store.getters.appVersion }}</div>
      </v-footer>
    </v-navigation-drawer>

    <top-toolbar
      v-if="$router.currentRoute.name != 'Login' && $router.currentRoute.name != 'Setup'"
      @sideNavUpdate="sideNavUpdate"
      @logout="onLogout"
    ></top-toolbar>

    <v-content>
      <div
        v-if="
          adminView && $router.currentRoute.name != 'Login' && $router.currentRoute.name != 'Setup'
        "
      >
        <v-alert
          v-model="subscriptionAlert"
          dense
          prominent
          type="error"
          style="border-radius: 1px"
        >
          <v-row align="center">
            <v-col class="grow">
              Your organisation’s account subscription
              <span v-if="expiryOver != true">is expiring soon</span>
              <span v-else>has ended</span>.
              <span v-if="$store.state.userDetails.role.toLowerCase() != 'superadmin'"
                >Please contact your administrator for renewal.</span
              >
            </v-col>

            <v-col class="shrink">
              <v-btn
                @click.native="$router.replace({ name: 'Subscription' })"
                v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                color="primary"
                dark
                >Renew</v-btn
              >
            </v-col>
          </v-row>
        </v-alert>
      </div>

      <div v-else-if="$router.currentRoute.name != 'Login' && $router.currentRoute.name != 'Setup'">
        <v-alert
          v-model="subscriptionAlert"
          dense
          prominent
          type="error"
          style="border-radius: 1px"
        >
          <v-row align="center">
            <v-col class="grow">
              Your organisation’s account subscription has ended. Please contact your administrator
              for renewal.
            </v-col>
          </v-row>
        </v-alert>
      </div>

      <v-banner
        v-if="
          $store.state.userDetails &&
            $router.currentRoute.name != 'Login' &&
            $router.currentRoute.name != 'Setup'
        "
        style="margin-top: -20px;"
      ></v-banner>

      <router-view :key="$route.fullPath"></router-view>

      <v-dialog v-model="dialogZoom" max-width="40vw" content-class="reg__boxShadowHide">
        <img :src="selectedZoomImage" @click.stop="dialogZoom = false" />
      </v-dialog>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "firebase";
import "@/styles/styles.sass";
import "@/components/toolbar/toolbar";
import "@/styles/style.css";
import "@/styles/style.scss";
import canSee from "@/utilities/canSee";
import moment from "moment-timezone";
import { filter } from "minimatch";
import permission from "@/utilities/permissions";
import VBanner from "@/components/firstTimeBanner/banner.vue";

export default {
  components: { VBanner },
  data() {
    return {
      expiryOver: false,
      selectedZoomImage: "",
      dialogZoom: false,
      dataRendered: false,
      planExpiry: "",
      sideNav: false,
      clipped: false,
      drawer: true,
      fixed: false,
      computeLogo: require("@/assets/logo-reg.png"),

      scrollSettings: {
        maxScrollbarLength: 160
      },
      userProfileImage: ""
    };
  },
  computed: {
    defaultImage() {
      function getImageAttachment(src, self) {
        if (src == undefined || src == "") {
          const demoImg = require("@/assets/demo.png");
          return demoImg;
        }
        return self.$store.state.imagePath + src.insert(src.lastIndexOf("."), "_200x200");
      }

      return getImageAttachment(this.$store.getters.profilePicture, this);
    },
    menuItems() {
      const menuItems = [];
      if (this.$store.state.userDetails) {
        const userData = this.$store.state.userDetails;

        menuItems.push({ icon: "home", title: "Home", link: "/" });
        menuItems.push({
          icon: "assignment_ind",
          title: "Members",
          link: "/members",
          subgroup: "true"
        });
        menuItems.push({
          icon: "timelapse",
          title: "Timesheet",
          link: "/timesheet"
        });

        if (userData.role != "User") {
          menuItems.push({
            icon: "important_devices",
            title: "Kiosk",
            link: "/kiosk"
          });
        }
      }
      return menuItems;
      // return menuItemsGroup
    },
    userIsAuthenticated() {
      console.log(
        "Is user authenticated",
        this.$store.getters.userDetails !== null &&
          this.$store.getters.userDetails !== undefined &&
          this.$router.currentRoute.name != "Login"
      );

      return (
        this.$store.getters.userDetails !== null &&
        this.$store.getters.userDetails !== undefined &&
        this.$router.currentRoute.name != "Login"
      );
    },

    adminView() {
      try {
        var role = this.$store.state.userDetails.role;

        if (role == "SuperAdmin" || role == "Admin") {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    },

    subscriptionAlert() {
      try {
        var self = this;
        var company = this.$store.getters.company;
        var expiry = moment(company.plan.expiryDate);
        var now = moment().format("DD/MM/YYYY HH:mm:ss");

        var expiryBeforeThreeDays = moment(company.plan.expiryDate)
          .subtract(3, "days")
          .format("DD/MM/YYYY HH:mm:ss");

        var durationofThreeDays = moment(now, "DD/MM/YYYY HH:mm:ss").diff(
          moment(expiryBeforeThreeDays, "DD/MM/YYYY HH:mm:ss"),
          "seconds"
        );

        var duration = moment(now, "DD/MM/YYYY HH:mm:ss").diff(
          moment(expiry, "DD/MM/YYYY HH:mm:ss"),
          "seconds"
        );

        if (duration > 0) {
          self.expiryOver = true;
        } else {
          self.expiryOver = false;
        }

        if (durationofThreeDays > 0) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    emailValidationAlert() {
      try {
        var company = this.$store.getters.company;
        if (!company.emailVerified) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    }
  },
  mounted() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  created() {
    document.addEventListener("deviceready", function() {
      if (!permission.camera.authorized()) {
        permission.camera.request();
      }

      if (!permission.location.authorized()) {
        permission.location.request();
      }

      cordova.plugins.Keyboard.shrinkView(true);
      window.Keyboard.disableScrollingInShrinkView(true);
    });

    this.$store.dispatch("realtimeDBSetup");
  },

  methods: {
    onRefresh() {
      var currentRoute = self.$route.fullPath;

      if (currentRoute == "/") self.$router.replace("/help");
      else self.$router.replace("/");

      self.$nextTick(() => {
        self.$router.replace(currentRoute);
      });
    },
    getImageAttachment(src) {
      if (src == undefined || src == "") {
        const demoImg = require("@/assets/demo.png");
        return demoImg;
      }
      return this.$store.state.imagePath + src.insert(src.lastIndexOf("."), "_200x200");
    },
    zoom(url) {
      url = url.replace("_200x200", "");
      this.dialogZoom = true;
      this.selectedZoomImage = url;
    },
    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },

    sideNavUpdate(sideNav) {
      this.sideNav = !this.sideNav;
    },
    onLogout() {
      try {
        this.$http
          .post(`${this.$store.state.endpoint}Accounts/logout`)
          .then(res => {
            firebase
              .auth()
              .signOut()
              .then(() => {
                window.localStorage.clear();
                window.location.reload();
              })
              .catch(err => {
                console.log(err);

                window.localStorage.clear();
                window.location.reload();
              });
          })
          .catch(err => {
            window.localStorage.clear();
            window.location.reload();
          });

        //
      } catch (e) {
        console.log(e);

        window.localStorage.clear();
        window.location.reload();
      }
    }
  }
};
</script>
<style scoped>
.sidebar-h5 {
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: bold;
  padding-left: 4px;
  margin-top: 2px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-p {
  font-size: 12px;
  font-weight: 0 !important;
  letter-spacing: 0.5px;
  padding-left: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.items_title {
  font-size: 14px !important;
  height: 20px;
  line-height: 20px;
  position: relative;
  text-align: left;
}

.v-dialog,
.v-dialog__content {
  -webkit-overflow-scrolling: touch !important;
}

*,
html {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-overflow-scrolling: touch;
}

input,
textarea {
  -webkit-user-select: auto !important;
  -khtml-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  user-select: auto !important;
}

html {
  touch-action: manipulation !important;
}
.ptr {
  font-family: Roboto, Noto, Helvetica, Arial, sans-serif;
}

.mx-datepicker-popup {
  position: initial !important;
}

.customRoundedNumber {
  height: 32px;
  width: 35px;
  background-color: #5dc3f8;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}

.v-navigation-drawer__content::-webkit-scrollbar {
  display: none;
}

.v-list-group__header .v-list-item .v-list-item--active .v-list-item--link .theme--dark {
  color: white;
}

.matchHeight {
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100) !important;
}
</style>
